import script from "./shipmentListCont.vue?vue&type=script&setup=true&name=chipmentListCont&lang=js"
export * from "./shipmentListCont.vue?vue&type=script&setup=true&name=chipmentListCont&lang=js"

const __exports__ = script;

export default __exports__